module.exports = __webpack_public_path__ + "static/media/n28.be0a001f.jpg";